import { css } from '@emotion/react';
import React, { memo } from 'react';
import { flex } from '~/modules/AppLayout/FlexGridCss';
import { AppLink } from '~/components/AppLink';
import { fontWeight600 } from '~/css/font';
import PercentageBarChart from '~/modules/tradeSheet/tradingSummary/PercentageBarChart';
import { useTradingSummaryState } from '~/modules/tradeSheet/tradingSummary/useTradingSummaryState';
import { rateboxCss, rateKeyCss, rateChartCss, rateValueCss, } from '~/modules/tradeSheet/tradingSummary/tradingSummaryCss';
const ReturnRate = memo(function ReturnRate() {
    const { state } = useTradingSummaryState.useContainer();
    const { groupReturnRates: { mine, txf, adviser }, } = state;
    const barRefPercentage = Math.max(Math.abs(mine), Math.abs(txf), Math.abs(adviser));
    return (<>
      <div css={css `
          ${flex.v.default};
          width: 100%;
        `}>
        <div css={rateboxCss}>
          <p css={rateKeyCss}>我的收益率</p>
          <p css={rateChartCss}>
            <PercentageBarChart percentage={mine ?? 0} denominator={barRefPercentage} width={250}/>
          </p>
          <p css={rateValueCss}>{mine?.toFixed(1)}%</p>
        </div>
        <div css={rateboxCss}>
          <p css={rateKeyCss}> 大盤收益率</p>
          <p css={rateChartCss}>
            <PercentageBarChart percentage={txf ?? 0} denominator={barRefPercentage} width={250}/>
          </p>
          <p css={rateValueCss}>{txf?.toFixed(1)}%</p>
        </div>
        <div css={rateboxCss}>
          <p css={rateKeyCss}>期顧收益率</p>
          <p css={rateChartCss}>
            <PercentageBarChart percentage={adviser ?? 0} denominator={barRefPercentage} width={250}/>
          </p>
          <p css={rateValueCss}>{adviser?.toFixed(1)}%</p>
        </div>
        <div css={css `
            ${flex.v.allCenter};
            width: 100%;
            ${fontWeight600};
            margin-top: 25px;
          `}>
          <p css={css `
              font-size: 14px;
            `}>
            <AppLink target='_blank' href='https://www.fubon.com/futures/advisor/starwin/performance.pdf'>
              ➤期顧：追蹤更多優質期顧投組
            </AppLink>
          </p>
          <p css={css `
              font-size: 14px;
            `}>
            <AppLink target='_blank' href='https://www.fubon.com/futures/home/business/introduce.html'>
              ➤期經：了解期貨全權委託商品
            </AppLink>
          </p>
        </div>
      </div>
    </>);
});
export default ReturnRate;
